import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 flex items-center">
                            <img className="h-8 w-auto" src="logo.png" alt="Sudesh Maths" />
                        </div>
                        <span className="text-gray-900 font-bold text-xl ml-3 lemon-milk hidden sm:block">Sudesh Maths</span>
                    </div>

                    <div className="hidden md:flex items-center gap-8">
                        <a href="#" className="relative group text-gray-700 font-medium lemon-milk px-2 py-1 transition-all duration-300 hover:text-blue-600">
                            <span>Home</span>
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                        <a href="#" className="relative group text-gray-700 font-medium lemon-milk px-2 py-1 transition-all duration-300 hover:text-blue-600">
                            <span>Courses</span>
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                        <a href="#" className="relative group text-gray-700 font-medium lemon-milk px-2 py-1 transition-all duration-300 hover:text-blue-600">
                            <span>Our Lecturers</span>
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                        <a href="#" className="relative group text-gray-700 font-medium lemon-milk px-2 py-1 transition-all duration-300 hover:text-blue-600">
                            <span>Time Table</span>
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                        <button
                            onClick={() => navigate('/feedback')}
                            className="relative group text-gray-700 font-medium lemon-milk px-2 py-1 transition-all duration-300 hover:text-blue-600">
                            <span>Student Feedback</span>
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                        </button>
                        <a href="#" className="relative group text-gray-700 font-medium lemon-milk px-2 py-1 transition-all duration-300 hover:text-blue-600">
                            <span>FAQ</span>
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                        <button
                            onClick={() => navigate('/login')}
                            className="relative overflow-hidden group bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-2.5 rounded-lg font-medium transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg lemon-milk">
                            <span className="relative z-10">Student Login</span>
                            <span className="absolute inset-0 bg-white/10 group-hover:bg-white/5 backdrop-blur-sm transition-all duration-300 transform -translate-x-full group-hover:translate-x-0"></span>
                            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-white/30 group-hover:bg-white/50 transition-all duration-500 transform scale-x-0 group-hover:scale-x-100 origin-left"></span>
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center">
                        <button
                            onClick={toggleMobileMenu}
                            className="text-gray-700 p-2 focus:outline-none"
                            aria-label="Toggle menu"
                        >
                            {isMobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${isMobileMenuOpen ? 'max-h-96' : 'max-h-0'}`}>
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-200">
                    <a
                        href="#"
                        className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                        onClick={closeMobileMenu}
                    >
                        Home
                    </a>
                    <a
                        href="#"
                        className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                        onClick={closeMobileMenu}
                    >
                        Courses
                    </a>
                    <button
                        className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                            closeMobileMenu();
                            navigate('/feedback');
                        }}
                    >
                        Student Feedback
                    </button>
                    <a
                        href="#"
                        className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
                        onClick={closeMobileMenu}
                    >
                        FAQ
                    </a>
                    <button
                        className="w-full mt-2 bg-blue-600 text-white px-4 py-2 rounded-md font-medium hover:bg-blue-700 transition-colors"
                        onClick={() => {
                            closeMobileMenu();
                            navigate('/login');
                        }}
                    >
                        Student Login
                    </button>
                </div>
            </div>
        </nav>
    );
}
